module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S9 Titanium Gray.e5dc1d95.png";